<h1>
  <span class="text-nowrap me-2">
    <my-global-icon iconName="subscriptions" aria-hidden="true"></my-global-icon>
    <ng-container i18n>My subscriptions</ng-container>
    <span *ngIf="pagination.totalItems" class="pt-badge badge-secondary"> {{ pagination.totalItems }}</span>
  </span>
</h1>

<div class="video-subscriptions-header">
  <my-advanced-input-filter (search)="onSearch($event)"></my-advanced-input-filter>
</div>

<div class="no-results" i18n *ngIf="pagination.totalItems === 0">You don't have any subscription yet.</div>

<div class="actors" myInfiniteScroller (nearOfBottom)="onNearOfBottom()" [dataObservable]="onDataSubject.asObservable()">
  <div *ngFor="let videoChannel of videoChannels" class="actor">
    <my-actor-avatar [actor]="videoChannel" actorType="channel" [internalHref]="[ '/c', videoChannel.nameWithHost ]" size="80"></my-actor-avatar>

    <div class="actor-info">
      <a [routerLink]="[ '/c', videoChannel.nameWithHost ]" class="actor-names" i18n-title title="Channel page">
        <div class="actor-display-name">{{ videoChannel.displayName }}</div>
        <div class="actor-name">{{ videoChannel.nameWithHost }}</div>
      </a>

      <div i18n class="actor-followers">{{ videoChannel.followersCount }} subscribers</div>

      <a [routerLink]="[ '/a', videoChannel.ownerBy ]" i18n-title title="Owner account page" class="actor-owner">
        <span i18n>Created by {{ videoChannel.ownerBy }}</span>

        <my-actor-avatar [actor]="videoChannel.ownerAccount" actorType="account" size="18"></my-actor-avatar>
      </a>
    </div>

    <my-subscribe-button [videoChannels]="[videoChannel]"></my-subscribe-button>
  </div>
</div>
